const formatBytes = (bytes?: number, lowerCase?: boolean) => {
  if (!bytes) return '-';
  const BYTE_MAP = {
    GIGABYTE: 1000000000,
    MEGABYTE: 1000000,
    KILOBYTE: 1000,
  };
  // Not using while loop, since the file uploaded will not exceed certain amount
  let suffix = 'B';
  let newBytes = bytes;
  if (bytes > BYTE_MAP.GIGABYTE) {
    newBytes = bytes / BYTE_MAP.GIGABYTE;
    suffix = 'GB';
  } else if (bytes > BYTE_MAP.MEGABYTE) {
    newBytes = bytes / BYTE_MAP.MEGABYTE;
    suffix = 'MB';
  } else if (bytes > BYTE_MAP.KILOBYTE) {
    newBytes = bytes / BYTE_MAP.KILOBYTE;
    suffix = 'KB';
  }
  let byteString = `${Math.round(newBytes * 10) / 10} ${suffix}`;
  if (lowerCase) byteString = byteString.toLowerCase();
  return byteString;
};

export default formatBytes;
